import React, { FC } from 'react';

import getClassName from 'src/common/utils/getClassName';

import s from './EventDetailsFooter.module.scss';

type EventDetailsFooter = {
  classNameModifier?: string;
};

const EventDetailsFooter: FC<EventDetailsFooter> = ({ children, classNameModifier }) => (
  <div className={getClassName(s, 'root', classNameModifier)}>
    {children}
  </div>
);

export default EventDetailsFooter;
